import { Reveal, Overline } from "./Reveal";
import { Video, MessageCircle, Repeat, Clock, GraduationCap } from "lucide-react";

const STRUCTURE = [
  { i: GraduationCap, t: "20 Sessions", d: "10 Strategic Learning + 10 Live Trading" },
  { i: Repeat, t: "Cadence", d: "Weekly (first half), every 2–3 weeks (second half)" },
  { i: Clock, t: "90 mins each", d: "Impartation, coaching, mentoring & hands-on" },
  { i: Video, t: "Live via Zoom", d: "Recordings provided for every class" },
  { i: MessageCircle, t: "WhatsApp support", d: "A single point of contact whenever you need" },
];

const AGENDA = [
  { r: "0–5", t: "Greetings & life event updates" },
  { r: "5–7", t: "Tasks accomplished prior week" },
  { r: "7–12", t: "Q&A on any unclear tasks" },
  { r: "12–15", t: "Intro today's main topic & outcome" },
  { r: "15–60", t: "Impartations to achieve the outcome" },
  { r: "60–85", t: "Mentorship & hands-on, solution-driven" },
  { r: "85–90", t: "Define the Call To Action for next week" },
];

export default function Program() {
  return (
    <section id="program" data-testid="program-section" className="relative py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="max-w-2xl mb-16">
          <Overline>Program Structure</Overline>
          <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-tight text-white mt-5">
            A rhythm built for real progress.
          </h2>
        </Reveal>

        <div className="grid lg:grid-cols-5 gap-6 mb-20">
          {STRUCTURE.map((s, i) => {
            const Icon = s.i;
            return (
              <Reveal key={s.t} delay={i * 0.06}>
                <div className="h-full rounded-2xl border border-white/10 bg-surface/40 p-6">
                  <Icon size={22} className="text-burgundy" />
                  <h3 className="font-body text-lg text-white mt-5">{s.t}</h3>
                  <p className="text-slate-400 text-sm mt-2 leading-relaxed">{s.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <Reveal>
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
              A typical session
            </span>
            <h3 className="font-display text-3xl md:text-5xl text-white mt-4 leading-tight">
              90 minutes, laser-focused.
            </h3>
            <p className="text-slate-400 mt-6 leading-relaxed max-w-md">
              Every session follows a proposed agenda so no minute is wasted. The
              impartation-to-hands-on ratio shifts from 80/20 toward 100% hands-on
              from session 11 onward.
            </p>
            <div className="mt-8 flex flex-wrap gap-3 font-mono text-xs">
              {["10pm SGT", "4pm CEST", "10am EST"].map((t) => (
                <span key={t} className="px-4 py-2 rounded-full border border-white/15 text-slate-200">
                  {t}
                </span>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="rounded-3xl border border-white/10 bg-surface/40 divide-y divide-white/10 overflow-hidden">
              {AGENDA.map((a) => (
                <div key={a.r} className="flex items-center gap-6 px-6 py-4 hover:bg-white/[0.03] transition-colors duration-300">
                  <span className="font-mono text-xs text-burgundy w-16 shrink-0">{a.r}m</span>
                  <span className="text-slate-200 text-sm">{a.t}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
